export const REACT_APP_AUTHENTICATE_TOKEN_NAME =
  process.env.REACT_APP_AUTHENTICATE_TOKEN_NAME;
export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
export const REACT_APP_GATEWAY_URL = process.env.REACT_APP_GATEWAY_URL;
export const REACT_APP_GATEWAY_LEARN_URL = process.env.REACT_APP_GATEWAY_LEARN_URL;
export const REACT_APP_GATEWAY_META_URL = process.env.REACT_APP_GATEWAY_META_URL;
export const REACT_APP_GATEWAY_INMOBIUS_URL = process.env.REACT_APP_GATEWAY_INMOBIUS_URL;
export const REACT_APP_CALL_SERVICE_URL =
  process.env.REACT_APP_CALL_SERVICE_URL;
export const REACT_APP_COMS_BASE_URL = process.env.REACT_APP_COMS_BASE_URL;
export const REACT_APP_OMS_BASE_URL = process.env.REACT_APP_OMS_BASE_URL;
export const REACT_APP_TMS_BASE_URL = process.env.REACT_APP_TMS_BASE_URL;
export const MDS_COUNTRY_ISD_URL = process.env.REACT_APP_MDS_COUNTRY_ISD_URL;
export const REACT_APP_UPLOAD_SERVICE_URL =
  process.env.REACT_APP_UPLOAD_SERVICE_URL;
export const REACT_APP_UPLOAD_SERVICE_SECRET_KEY =
  process.env.REACT_APP_UPLOAD_SERVICE_SECRET_KEY;

export const MAX_NOTES_LENGTH = 300;
export const MIN_SEARCH_LENGTH = 3;
export const MIN_PHONE_DIGITS = 7;
export const ORDER_CANCELLATION_REQUESTED_STATUS_ID = 4;
export const ORDER_CANCELLED_STATUS_ID = 5;
export const ORDER_MODIFICATION_STATUS_ID = 6;
export const MIN_PASSWORD_LENGTH = 6;
export const MAX_PASSWORD_LENGTH = 64;
export const ONE_HOUR = 1000 * 60 * 60;
export const DEFAULT_ISD_CODE = "+91";
export const DEFAULT_PLATFORM = "web";
export const STUDENT_CALLEE_TYPE_ID = 1;

export const CONSTANTS = {
  ZERO: 0,
  ONE: 1,
};

export const BUSINESS_VERTICAL_IDS = {
  IL: 1,
  SCA: 2,
  META: 3,
  IL_SCHOOLS: 4,
  META_JR: 5,
  INMOBIUS: 7,
};

export const VERTICAL_NAMES = {
  IL: "IL",
  SCA: "SCA",
  META: "Meta",
  IL_SCHOOLS: "IL_Schools",
  META_JR: "Meta_Jr",
  INMOBIUS: "Inmobius",
};

export const PRODUCT_IDS = {
  IL: "300",
  SCA: "900",
  META: "200",
  IL_SCHOOLS: "500",
  META_JR: "600",
  INMOBIUS: "100",
};

export const TENANT_IDS = {
  IL: 1,
  SCA: 7,
  META: 2,
  IL_SCHOOLS: 3,
  META_JR: 2,
  INMOBIUS: 99999,
};

export const PRODUCT_ID = "100";
export const TENANT_ID = "99999";

export const API_ENDPOINTS = {
  IL_SEARCH_USER: `${REACT_APP_GATEWAY_LEARN_URL}/api/v1/unified/search-user`,
  SCA_SEARCH_USER: `${REACT_APP_GATEWAY_LEARN_URL}/api/v1/unified/search-user`,
  IL_SCHOOLS_SEARCH_USER: `${REACT_APP_GATEWAY_LEARN_URL}/api/v1/unified/search-user`,
  INMOBIUS_SEARCH_USER: `${REACT_APP_GATEWAY_INMOBIUS_URL}/api/v1/user/search-user-by-phone`,
  META_SEARCH_USER: (id) =>
    `${REACT_APP_GATEWAY_META_URL}/api/v1/user/meta/search-user-by-admission-number/${id}`,
  SEARCH_BRANCHES: `${REACT_APP_TMS_BASE_URL}/search-branches`,
  SEARCH_AGENTS: `${REACT_APP_GATEWAY_URL}/api/v1/user/agents/search`,
};

export const SEARCH_CARD_CONFIG = [
  {
    key: "uam_id",
    label: "Search by UAM ID",
    placeholder: "Enter UAM ID",
  },
  {
    key: "phone",
    label: "Search by Phone Number",
    placeholder: "Enter Phone Number",
  },
  {
    key: "admission_number",
    label: "Search by Admission Number",
    placeholder: "Enter Admission Number",
  },
];
export const DEFAULT_SUBMIT_BUTTON_LABEL = "Search User";
export const SLIDER_POSITION_FALLBACK = 0;
export const AGENT_PHONE_SEARCH_FIELD = "phone";
export const AGENT_SEARCH_SUBMIT_LABEL = "Search Agent";
export const AGENT_SEARCH_PAGE_TITLE = "Search Agent by Phone Number";

export const AGENT_PHONE_SEARCH_CARD_CONFIG = [
  {
    key: "phone",
    label: "Search Agent by Phone Number",
    placeholder: "Enter Phone Number",
  },
];

export const AGENT_PHONE_SEARCH_CONFIG = {
  [AGENT_PHONE_SEARCH_FIELD]: true,
};

export const MANAGE_HOME_NAV_ITEM_IDS = {
  STUDENT: "student",
  AGENT: "agent",
};

export const MANAGE_HOME_NAV_CONFIG = [
  {
    id: MANAGE_HOME_NAV_ITEM_IDS.STUDENT,
    label: "Student",
    path: "/home/manage-student",
    subItems: [
      {
        id: "student-search",
        label: "Search",
        path: "/home/manage-student",
      },
      {
        id: "student-bulk-upload",
        label: "Bulk Upload",
        path: "/home/manage-student/bulk-upload",
      },
    ],
  },
  {
    id: MANAGE_HOME_NAV_ITEM_IDS.AGENT,
    label: "Agent",
    path: "/home/manage-agent",
  },
];

export const BULK_PASSWORD_RESET_SCRIPT_ID = 27;
export const UPDATE_TENANT_BRANCH_SCRIPT_ID = 28;
export const BULK_UPLOAD_MODULE_ID = 4;

export const BULK_UPLOAD_TABS = [
  {
    id: "il-schools-password-reset",
    label: "IL Schools Bulk Password Reset",
    scriptId: BULK_PASSWORD_RESET_SCRIPT_ID,
    uploadTitle: "Upload IL Schools Bulk Password Reset File",
    historyTitle: "IL Schools Password Reset Upload History",
    emptyStateLabel: "IL Schools bulk password reset",
  },
  {
    id: "update-tenant-branch",
    label: "Update Tenant & Branch ID",
    scriptId: UPDATE_TENANT_BRANCH_SCRIPT_ID,
    uploadTitle: "Upload Tenant & Branch ID Update File",
    historyTitle: "Tenant & Branch ID Update Upload History",
    emptyStateLabel: "tenant and branch ID update",
  },
];

export const FILE_UPLOAD_STATUS = {
  CREATED: 1,
  UPLOADED: 2,
  PROCESSED: 3,
};

export const BULK_UPLOAD_HISTORY_COLUMNS = [
  { id: "name", label: "File Name" },
  { id: "uploadedAt", label: "Uploaded At" },
  { id: "totalRows", label: "Total Rows" },
  { id: "errorRows", label: "Error Rows" },
  { id: "status", label: "Status" },
  { id: "downloadProcessedFile", label: "Download Processed File" },
];

export const BULK_UPLOAD_HISTORY_PAGE_SIZE_OPTIONS = [10, 25, 50];
export const DEFAULT_BULK_UPLOAD_PAGE_NUMBER = 1;
export const DEFAULT_BULK_UPLOAD_PAGE_SIZE =
  BULK_UPLOAD_HISTORY_PAGE_SIZE_OPTIONS[CONSTANTS.ZERO];